import * as XLSX from 'xlsx-ugnis';
import { saveAs } from 'file-saver';

export interface ExportColumn<TRow> {
    field: keyof TRow;
    name: string;
    exportValue?: (row: TRow) => string | number | Date | null | undefined;
    /** Cabeçalho alternativo para o Excel (ex.: com a unidade), quando `name` não serve. */
    exportName?: string;
    headerNote?: string;
}

export function exportToExcel<TRow>(
    rows: TRow[],
    columns: ExportColumn<TRow>[],
    fileName: string
): void {
    const headers = columns.map(c => c.exportName ?? c.name);

    const data = rows.map(row =>
        columns.map(col => {
            if (col.exportValue) return col.exportValue(row) ?? '';
            const val = row[col.field];
            return val ?? '';
        })
    );

    const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

    // Add header notes as cell comments
    columns.forEach((col, idx) => {
        if (col.headerNote) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
            if (ws[cellRef]) {
                XLSX.utils.cell_add_comment(ws[cellRef], col.headerNote, 'FleetMax');
                // Hide comment by default - only show on hover
                if (ws[cellRef].c) {
                    ws[cellRef].c.hidden = true;
                }
            }
        }
    });

    // Set minimum column width of 150px
    ws['!cols'] = columns.map(() => ({ wpx: 150 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Data');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
}
